var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-users-log',{attrs:{"current_page":_vm.current_page,"data":_vm.users,"itemsPerPage":_vm.itemsPerPage,"loading":_vm.loading,"pageCount":_vm.pageCount,"title":_vm.title},on:{"paginate":_vm.getUsers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }